import { render } from "./TransactionHistory.vue?vue&type=template&id=171b6890"
import script from "./TransactionHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionHistory.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/TransactionHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "171b6890"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('171b6890', __exports__)) {
    api.reload('171b6890', __exports__)
  }
  
  module.hot.accept("./TransactionHistory.vue?vue&type=template&id=171b6890", () => {
    api.rerender('171b6890', render)
  })

}


export default __exports__